// App Insights connection string sourced from environment variable (set during build via pipeline)
const APPINSIGHTS_CONNECTION_STRING: string = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING || "";

export default APPINSIGHTS_CONNECTION_STRING;
